// See web/app/themes/jcf-theme/acf/social-media-carousel.twig

import "slick-carousel";
import twitter from "twitter-text";
import $ from "jquery";

const token =
  "IGQVJYUTN0cGkwV3FOWG1BV3hRZAjVyQUV3T3hIR0pQa01BZAzRUQTR5a2dOS0RmaEcxRUdOODU4UGY4bGZAEdG9teDl4cTRaempOcDY5YnlEekdZANmtRWlhsMUliUGtubFVuUUk5TEJn";

// const bigInt = require("big-integer");

let // $carousel,
  // content,
  // currentPage = 0,
  active = "all",
  $profile = "",
  statuses = [];

class SocialMediaCarousel {
  async getPinned(id) {
    if (!id) return;
    try {
      const res = await fetch(`/wp-json/twitter/v1/statuses/${id}`);
      return res.data;
    } catch (error) {
      // console.error("error", error);
    }
  }

  async getTweets(page = 0) {
    try {
      const res = await fetch(`/wp-json/twitter/v1/tweets/${page}`);
      // console.info(res.headers)
      return res.data;
    } catch (error) {
      // console.error("error", error);
    }
  }

  async getProfile() {
    try {
      const data = await fetch(`/wp-json/twitter/v1/profile`).then(
        (res) => res.data,
      );
      return data.length ? data[0] : false;
    } catch (error) {
      // console.error("error", error);
    }
  }

  // getInstagramUrlFromMediaId(post) {
  //   console.log(post)
  //   var {media_id} = post;
  //   var alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
  //   var shortenedId = '';
  //   // media_id = media_id.substring(0, media_id.indexOf('_'));
  //
  //   while (media_id > 0) {
  //       var remainder = bigInt(media_id).mod(64);
  //       media_id = bigInt(media_id).minus(remainder).divide(64).toString();
  //       shortenedId = alphabet.charAt(remainder) + shortenedId;
  //   }
  //
  //   return 'https://www.instagram.com/p/' + shortenedId + '/';
  // }

  async getInstagram() {
    try {
      const res = await fetch(
        `https://graph.instagram.com/me/media?fields=id,caption,media_url,timestamp,permalink,username&access_token=${token}`,
      );
      const {
        data: { data },
      } = res;
      // const media = data.map((d) => d.id);
      // console.log( data.length, res )
      return data.length ? data : [];
    } catch (error) {
      // console.error("error", error);
    }
  }

  buildTwitterSlide(post) {
    const tweet = Object.assign({}, post);

    let pinned = tweet.pinned ? "data-pinned" : "";
    let media = tweet.media_url
      ? `<img loading="lazy" src="${tweet.media_url}" />`
      : "";
    let text = twitter.autoLink(tweet.full_text, tweet.entities);

    const textwithlinks = function (input, entities) {
      // const urls = entities.urls;
      let text = input;
      entities.urls.forEach((item) => {
        text = text.replaceAll(item.url, item.expanded_url);
      });

      return text;
    };

    text = textwithlinks(text, tweet.entities);
    const date = tweet.date
      .toLocaleDateString("en-GB", {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
      })
      .replaceAll("/", ".");
    const $tweet = $(
      `<div id="${tweet.id}" class="slide twitter all" data-type="twitter"><span class="twitter__tweet" ${pinned}>${$profile}<p>${text}</p>${media}<time>${date}</time></span></div>`,
    );
    $tweet.find("a").attr("target", "_blank");
    return $tweet;
  }

  addSlides(posts = [], filter = false) {
    if (filter) {
      posts = posts.filter((post) => post.type == filter);
    }

    posts.forEach((post) => {
      let slide, date;
      if (post.created_at) {
        // this is twitter
        fetch(`/wp-json/twitter/v1/statuses/${post.id_str}`).then((status) => {
          const { data } = status;
          const { entities } = data;
          const { media } = entities;
          if (media && media.length) {
            // console.log(media[0], data)
            const status = {
              id: data.id,
              media_url: media[0].media_url_https,
            };
            statuses.push(status);
            // UNique array
            statuses = [
              ...new Map(statuses.map((item) => [item["id"], item])).values(),
            ];

            posts.forEach((post, i) => {
              if (post.id === data.id) {
                posts[i] = Object.assign({}, post, status);
                $(`#${post.id}`).replaceWith(this.buildTwitterSlide(posts[i]));
              }
            });
          }
        });

        slide = this.buildTwitterSlide(post);
      }

      if (post.timestamp) {
        // this is instagram
        const caption = post.caption
          ? jQuery
              .trim(post.caption)
              .substring(0, 256)
              .split(" ")
              .slice(0, -1)
              .join(" ") + "..."
          : "";
        date = post.date
          .toLocaleDateString("en-GB", {
            year: "2-digit",
            month: "2-digit",
            day: "2-digit",
          })
          .replaceAll("/", ".");
        slide = `<div class="slide instagram all" data-type="instagram"><a target="_blank" title="Se post on Instagram" href="${post.permalink}" class="instagram__post"><img loading="lazy" src="${post.media_url}" /><p>${caption}</p><time>${date}</time></a></div>`;
      }

      $(".slick").append(slide);
    });
  }

  initSlide() {
    $(".slick").slick({
      lazyLoad: "ondemand",
      dots: false,
      arrows: false,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      // variableWidth: true,
      adaptiveHeight: true,
      centerPadding: "4rem",
      ease: "Pow4.easeIn",
      // customPaging: function(slider, i) {
      //   // this example would render "tabs" with titles
      //   var n = ('0' + (i+1)).slice(-2);
      //   return `<span class="dot" data-no="${n}">${n}</span>`;
      // },
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            dots: false,
            arrows: true,
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 768,
          settings: {
            dots: true,
            arrows: true,
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
      ],
    });
  }

  init() {
    if (!$("[social-carousel]").length) return;

    const sticky = $("[social-carousel]").data("pinned-tweet");

    fetch(
      `https://graph.instagram.com/refresh_access_token?grant_type=ig_refresh_token&access_token=${token}`,
    );
    // .then((res) => {
    //   const {
    //     data: { access_token, expires_in },
    //   } = res;
    //   console.info(`expires_in ${expires_in}`)
    // });

    Promise.all([
      this.getInstagram(),
      this.getProfile(),
      this.getTweets(),
      this.getPinned(sticky),
    ]).then((res) => {
      let [instagram, handle, tweets, pinned] = res;
      // let $profile = ''
      if (handle) {
        $profile = `<span class="twitter__profile"><figure class="twitter__figure"><img src="${handle.profile_image_url_https}" /></figure><span class="twitter__profile--handle"><span class="twitter__profile--name">${handle.name}</span><a target="_blank" href="https://twitter.com/${handle.screen_name}">@${handle.screen_name}</a></span></span>`;
      }
      if (pinned && !pinned.error) {
        pinned.pinned = true;
        tweets = tweets.filter((tweet) => tweet.id !== pinned.id);
        tweets.unshift(pinned);
      }

      var posts = tweets.concat(instagram);

      // Sort all the social media posts chronologically by date
      posts = posts
        .map((post) => {
          if (post.created_at) {
            post.type = "twitter";
            post.date = new Date(post.created_at);
          }
          if (post.timestamp) {
            post.type = "instagram";
            post.date = new Date(post.timestamp);
          }
          return post;
        })
        .sort((a, b) => b.date - a.date);

      // Move pinned posts to the front
      posts.some((item, idx) => {
        return item.pinned && posts.unshift(posts.splice(idx, 1)[0]);
      });

      // console.log(posts.filter(post=>{
      //   return post.text && post.full_text.includes('On this week')
      // }))

      smc.addSlides(posts, false);

      $(".slick").on("init", function () {
        $("[social-carousel] [data-type]").each(function () {
          $(this).closest(".slick-slide").addClass($(this).attr("class"));
        });
        $(".slick-filter a").show();
      });

      smc.initSlide();

      $(".slick-filter a").on("click", function () {
        var filter = $(this).data("type");
        if (active !== filter) {
          $(".slick").slick("unslick"); // Remove slick
          $(".slick").empty(); // Remove elements
          $(".slick-filter a").hide();
          $(this).addClass("active").siblings().removeClass("active");
          smc.addSlides(posts, filter !== "all" ? filter : false);
          smc.initSlide();
          active = filter;
        }
      });
    });
  }
}

export default SocialMediaCarousel;
